export interface PatientDeviceDataModel {
    medTeam: MedTeam;
    clinicDetails: ClinicDetailsModel;
    dropdowns: DropDownModel;
    messaging: MessagingModel;
    patient: PatientDetailsModel;
    patientDevices: PatientDeviceModel[];
    actionMsg: Message;
    leads: Lead[];
    showDeviceAtEos: boolean;
    showYellowBannerForApp: boolean;
    correctAbbrDevModelDesc: string;
    isFormModified: boolean;
    isValidInsNumber:boolean;
    isImplantPhysicianEditable: boolean;
}
export class Message {
    msg: string;
    childs: Message[];
    data: any;
}

export class Lead {
    manufacturer: string;
    location: LocationCode;
    length: number;
    modelNum: string;
    serialNum: string;
    implantDate: string;
}

export class LocationCode {
    codeId: number;
    code: string;
    qualifier: string;
    description: string;
}
export class UpdatePatientDeviceDataModel {
    medTeam: MedTeam;
    clinicDetails: ClinicDetailsModel;
    messaging: MessagingModel;
    patient: PatientDetailsModel;
    patientDevices: PatientDeviceModel[];
}

export interface MedTeam {
    availableIds: number[];
    assigned: number[];
    implantPhyId: number[];
}

export interface ClinicDetailsModel {
    activatorClinicFlg: boolean;
    timeFormat: string;
    dateFormat: string;
    dateFormatLabel: string;
    dateFormatLocale: string;
    timeZone: string;
    countryCd: number;
    trueAAIProdIds: string;
    icmProdIds: string;
    avrProdIds: string;
    ngqProdIds: string;
    unityProdIds:string;
    msgReminderFlg: boolean;
    msgOverdueFlg: boolean;
    schedulingMethodCd: number;
    deviceCheckFlg: boolean;
}

export class DropDownModel {
    ampm: valueLabelModel[];
    clinicians: cliniciansDropDownModel[];
    contactTypeCodes: ContactTypeCodesInterface[];
    countryCodes: ContactTypeCodesInterface[];
    device: valueLabelModel[];
    genderCodes: genderCodesDropDownModel[];
    langCodes: any[];
    leadChmbCodes: any[];
    locations: any[];
    raceCodes: any[];
    stateCodes: any[];
    devices: valueLabelModel[];
}

export interface valueLabelModel {
    value: string;
    label: string;
}

export interface cliniciansDropDownModel {
    acctId: number;
    altFirstName: string;
    altLastName: string;
    credentialsCd: any;
    firstName: string;
    lastName: string;
    mainLocation: string;
    middleName: string;
}

export interface genderCodesDropDownModel {
    codeId: number;
    code: string;
    qualifier: string;
    description: string;
}

export interface ContactTypeCodesInterface {
    code: string;
    codeId: number;
    qualifier: string;
}

export interface MessagingModel {
    callContactTypeCd: number;
    msgEndAmpm: string;
    msgEndTime: string;
    msgOverdueFlg: boolean;
    msgReminderFlg: boolean;
    msgStartAmpm: string;
    msgStartTime: string;
    patientCallSMS: string;
}

export interface AddressModel {
    addressId: any;
    address: string;
    address2: string;
    address3: string;
    city: string;
    countryCd: number;
    state: string;
    stateCd: any;
    state_province: any;
    zipCode: any;
}

export interface PatientDetailsModel {
    altFirstName: string;
    altLastName: string;
    dataMiningFlg: boolean;
    dateOfBirth: string;
    dateOfBirthStr: string;
    email: string;
    enrollmentDate: string;
    firstName: string;
    genderCd: string;
    languageCd: number;
    lastName: string;
    locationName: string;
    locationId: number;
    merlinNetId: number;
    middleName: string;
    patientId: number;
    patientNum: string;
    raceCd: string;
    raceConsentFlg: boolean;
    transmitterOrderFlg: boolean;
    address: AddressModel;
    phone: PhoneModel;
    notifyOnCallFlg: boolean;
    notifyOnCallPosition: number;
    customerApplPatientId: number;
    deviceCheckFlg: boolean;
    lockoutPatientInitTransFlg: boolean;
    lockoutPatientInitDcFlg: boolean;
    enableMedFlg: boolean;
    transmitterVolumeCd: boolean;
    patientStatusCd: number;
    patientMessagingReminderFlg: boolean;
    patientMessagingOverdueFlg: boolean;
    patientCallSms: string;
    transmitterOrderDate: string;
    insNumber: string;
    oidNumber: string;
    givenNames: string;
    usedGivenName: string;
    usedLastName: string;
    placeOfBirth: string;
    franceSsn: string;
}

export interface PhoneModel {
    countryCode: string;
    areaCode: string;
    number: string;
    phoneNum?: string;
    phoneId?: any;
}

export interface PatientDeviceModel {
    devChanged: boolean;
    implantDate: string;
    implantPhyId: number;
    leadChmbSettingCd: number;
    modelNum: number;
    productId: number;
    serialNum: number;
    implanterIds: number[];
    editReason: string;
    prevPatientDeviceId: number;
    prevProductId: number;
    prevSerialNum: number;
    isICMDevice: boolean;
    patientDeviceId: number;
    dataMiningFlg: boolean;
}

export interface EmergencyContactModel {
    address: AddressModel;
    deviceType: string;
    dropdowns: DropDownModel;
    firstName: string;
    lastName: string;
    notifyEmergencyContactFlg: boolean;
    patientId: number;
    phone: PhoneModel;
}
